// Address API service - replaces city and country APIs
import api from './apiClient';

export const addressAPI = {
    // Basic CRUD operations
    getAll: () => api.get('/addresses'),

    getById: (id) => api.get(`/addresses/${id}`),

    create: (addressData) => api.post('/addresses', addressData),

    update: (id, addressData) => api.put(`/addresses/${id}`, addressData),

    delete: (id) => api.delete(`/addresses/${id}`),

    // Search and filtering
    search: (searchTerm, page = 0, size = 20) =>
        api.get('/addresses/search', {
            params: { searchTerm, page, size }
        }),

    getByCountry: (countryCode) =>
        api.get('/addresses/by-country', {
            params: { countryCode }
        }),

    getByCity: (city) =>
        api.get('/addresses/by-city', {
            params: { city }
        }),

    findNearLocation: (latitude, longitude, radiusKm = 10) =>
        api.get('/addresses/near', {
            params: { latitude, longitude, radiusKm }
        }),

    // Google Places integration
    getByPlaceId: (placeId) =>
        api.get(`/addresses/by-place-id/${placeId}`),

    createWithPlaceId: (placeId, addressType = 'GENERAL') =>
        api.post('/addresses/with-place-id', null, {
            params: { placeId, addressType }
        }),

    resolveOrCreateByPlaceId: (placeId) =>
        api.post('/addresses/resolve-place-id', null, {
            params: { placeId }
        }),

    getOrCreate: (addressData) =>
        api.post('/addresses/get-or-create', addressData),

    // Address validation
    validatePlaceId: (placeId) =>
        api.post('/address-validation/validate-place-id', null, {
            params: { placeId }
        }),

    findByPlaceId: (placeId) =>
        api.get('/address-validation/find-by-place-id', {
            params: { placeId }
        }),

    validateAddress: (city, countryCode, streetAddress = null, postalCode = null) =>
        api.post('/address-validation/validate-address', null, {
            params: { city, countryCode, streetAddress, postalCode }
        }),

    // Convenience methods
    createFromGooglePlace: async (placeData, addressType = 'VENUE') => {
        // If we have a placeId, use the optimized Google Places workflow
        if (placeData.placeId) {
            return addressAPI.createWithPlaceId(placeData.placeId, addressType);
        }

        // Fallback to manual address creation
        const addressData = {
            streetAddress: placeData.streetAddress,
            city: placeData.city,
            stateProvince: placeData.state,
            postalCode: placeData.postalCode,
            country: placeData.country,
            countryCode: placeData.countryCode,
            latitude: placeData.coordinates?.lat,
            longitude: placeData.coordinates?.lng,
            formattedAddress: placeData.formattedAddress,
            addressType: addressType
        };

        return addressAPI.create(addressData);
    },

    // Helper to convert old city/country format to address format
    migrateCityCountryToAddress: async (cityName, countryName, additionalData = {}) => {
        const addressData = {
            city: cityName,
            country: countryName,
            addressType: additionalData.addressType || 'GENERAL',
            ...additionalData
        };

        return addressAPI.getOrCreate(addressData);
    }
};

export default addressAPI;
